import React, { type ReactElement } from 'react';
import { PREMIUM_EDITION } from '@jira/platform__application-editions/src/edition.tsx';
import { SpotlightTarget, SpotlightTransition } from '@atlaskit/onboarding';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import { JiraSpotlight } from '@atlassian/jira-spotlight/src/ui/jira-spotlight.tsx';
import { useAppEditions } from '@atlassian/jira-tenant-context-controller/src/components/app-editions/index.tsx';
import { useHasSeenOnboarding } from '../../../services/has-seen-onboarding/index.tsx';
import messages from './messages.tsx';

const SPOTLIGHT_KEY =
	'jira.servicedesk.incident-management.incident-management-settings.setting-menu-onboarding';

const IncidentManagementProductSettingNavMenuItemOnboarding = ({
	children,
	isFullyExpanded,
}: {
	children: ReactElement;
	isFullyExpanded: boolean;
}): React.JSX.Element => {
	const appEditions = useAppEditions();
	const [isOnboardingActive, setHasSeenOnboarding] = useHasSeenOnboarding(SPOTLIGHT_KEY);
	const { formatMessage } = useIntl();
	const hasPremiumServiceDeskAccess = appEditions.serviceDesk === PREMIUM_EDITION;

	return (
		<>
			<SpotlightTarget name="jira-servicedesk-incident-management-product-setting-menu-item">
				{children}
			</SpotlightTarget>
			<SpotlightTransition>
				{isOnboardingActive && isFullyExpanded && hasPremiumServiceDeskAccess && (
					<JiraSpotlight
						actions={[
							{
								onClick: setHasSeenOnboarding,
								text: formatMessage(
									messages.productSettingsIncidentManagementMenuItemSpotlightActionLabel,
								),
							},
						]}
						heading={formatMessage(
							messages.productSettingsIncidentManagementMenuItemSpotlightHeading,
						)}
						target="jira-servicedesk-incident-management-product-setting-menu-item"
						key="jira-servicedesk-incident-management-product-setting-menu-item"
						targetRadius={3}
						targetBgColor={token('elevation.surface')}
						messageType="engagement"
						messageId="servicedesk-incident-management-settings.common.ui.setting-menu-onboarding.jira-spotlight.jira-servicedesk-incident-management-product-setting-menu-item"
						dialogPlacement="right top"
					>
						{formatMessage(messages.productSettingsIncidentManagementMenuItemSpotlightDescription)}
					</JiraSpotlight>
				)}
			</SpotlightTransition>
		</>
	);
};

export default IncidentManagementProductSettingNavMenuItemOnboarding;
